import React, { useState, useRef, useEffect } from "react";
import BreadCrumb from "Common/BreadCrumb";
import { Upload, X, FileText } from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const BakeryQuotasUpload = () => {
    const navigate = useNavigate();
    const [file, setFile] = useState<File | null>(null);
    const [uploading, setUploading] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);
    useEffect(() => {
        // پاک‌سازی اولیه
        document.body.classList.remove('overflow-hidden');
        document.body.style.overflow = '';

        // نگهبان: اگر کلاس overflow-hidden دوباره اضافه شد، بلافاصله حذف کن
        const observer = new MutationObserver(() => {
            if (document.body.classList.contains('overflow-hidden')) {
                document.body.classList.remove('overflow-hidden');
                document.body.style.overflow = '';
            }
        });

        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['class'],
        });

        return () => observer.disconnect();
    }, []);
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];
        if (selectedFile) {
            // بررسی فرمت فایل
            const validTypes = [
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel",
            ];
            if (!validTypes.includes(selectedFile.type)) {
                toast.error("لطفاً فقط فایل اکسل (xlsx یا xls) انتخاب کنید");
                return;
            }
            setFile(selectedFile);
        }
    };

    const handleUpload = async () => {
        if (!file) {
            toast.error("لطفاً یک فایل انتخاب کنید");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        setUploading(true);
        try {
            const res = await axios.post(
                "https://rasad-api.havirard.ir/monitoring/bakery-quotas/upload/",
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("app_havir")}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            console.log(res, "res");

            toast.success("فایل با موفقیت بارگذاری شد");
            setTimeout(() => {
                navigate("/BakerQuota");
            }, 1500);
        } catch (err: any) {
            const message = err.response?.data?.detail || err.response?.data?.message || "خطا در بارگذاری فایل";
            toast.error(message);
        } finally {
            setUploading(false);
        }
    };

    const removeFile = () => {
        setFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    return (
        <React.Fragment>
            <BreadCrumb pageTitle="بارگذاری اکسل سهمیه‌ها" title="پایش آرد" />
            <ToastContainer position="top-center" closeButton={false} limit={3} rtl={true} />

            <div className="card">
                <div className="card-body">
                    <h5 className="text-lg font-semibold mb-4">بارگذاری فایل اکسل سهمیه خبازی‌ها</h5>

                    <div className="mb-4">
                        <p className="text-sm text-gray-500 mb-2">
                            فایل اکسل باید شامل ستون‌های: کد دوره، کد مرحله، شهرستان، کد خریدار، نام خریدار، انواع پخت و سه مقدار سهمیه باشد.
                        </p>
                    </div>

                    {/* باکس آپلود */}
                    <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl p-8 text-center">
                        {!file ? (
                            <div className="flex flex-col items-center gap-3">
                                <Upload size={40} className="text-gray-400" />
                                <p className="text-sm text-gray-500">
                                    فایل اکسل را اینجا بکشید یا کلیک کنید
                                </p>
                                <input
                                    type="file"
                                    accept=".xlsx,.xls"
                                    onChange={handleFileChange}
                                    ref={fileInputRef}
                                    className="hidden"
                                    id="file-upload"
                                />
                                <label
                                    htmlFor="file-upload"
                                    className="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg cursor-pointer hover:bg-blue-700 transition-colors"
                                >
                                    انتخاب فایل
                                </label>
                            </div>
                        ) : (
                            <div className="flex items-center justify-between bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                                <div className="flex items-center gap-3">
                                    <FileText size={24} className="text-blue-500" />
                                    <div className="text-left">
                                        <p className="text-sm font-medium text-gray-800 dark:text-gray-200">
                                            {file.name}
                                        </p>
                                        <p className="text-xs text-gray-500">
                                            {(file.size / 1024).toFixed(1)} کیلوبایت
                                        </p>
                                    </div>
                                </div>
                                <button
                                    onClick={removeFile}
                                    className="p-1 text-red-500 hover:bg-red-50 rounded-full transition-colors"
                                >
                                    <X size={18} />
                                </button>
                            </div>
                        )}
                    </div>

                    {/* دکمهٔ بارگذاری */}
                    <div className="flex justify-end gap-3 mt-4">
                        <button
                            onClick={() => navigate("/BakerQuota")}
                            className="px-4 py-2 text-sm bg-gray-100 rounded-lg hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600"
                        >
                            انصراف
                        </button>
                        <button
                            onClick={handleUpload}
                            disabled={!file || uploading}
                            className="px-4 py-2 text-sm text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {uploading ? "در حال بارگذاری..." : "بارگذاری فایل"}
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default BakeryQuotasUpload;